<template>
  <el-dialog title="Feedback" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <div class="img" :style="'background-image:url('+getImgS3(ruleForm.image)+')'">
      <img v-if="ruleForm.teethWhitening == 1" :style="'filter: brightness('+(ruleForm.brightness/50)+') saturate('+(ruleForm.saturate/50)+')  contrast('+(ruleForm.contrast/50)+');'" :src="getImgS3(ruleForm.imageMask)"/>
    </div>
    <el-form ref="form" v-loading="form_loading" label-width="120px" label-suffix=":" style="margin-right: 30px;margin-top: 20px;">
      <el-form-item label="Email">
        {{ruleForm.email}}
      </el-form-item>
      <el-form-item label="Practice Name">
        {{ruleForm.practiceName}}
      </el-form-item>
      <el-form-item label="Description">
        {{ruleForm.description}}
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { getAction } from '@/network/manage';
export default {
  name: 'Show',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      id: '',
      visible:false,
      ruleForm:{},
      rules: {
      },
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    getImgS3(key) {
      return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
    },
    init(id) {
      this.visible = true
      this.form_loading = true
      this.ruleForm = {}
      getAction('/admin/feedback/queryById?id='+id).then((res) => {
        if(res.success){
          this.ruleForm = res.result
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.message);
      }).finally((res) => {
        this.form_loading = false
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  >>>.el-form-item__label{line-height: 1.5;}
  >>>.el-form-item__content{line-height: 1.5;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  .img{width: 100%;height: 600px;background-size: cover;background-position: center;}
  .img img{width: 100%;height: 100%;object-fit: cover;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
     .img{width: 100%;height: 120vw;}
  }
</style>
